import { HttpClient, HttpEventType, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AzureBlobService {

  constructor(private http: HttpClient) { }

  private maxBlockSize: number;
  private totalBytesRemaining: number;
  private currentFilePointer = 0;
  private blockIds = new Array();
  private blockIdPrefix = 'block-';
  private bytesUploaded = 0;
  private file: File;
  private fileUrl: string;
  private cancelled = false;
  public progressCall: Subject<any> = new Subject<any>();
  public errorCall: Subject<any> = new Subject<any>();
  public uploadFinishedCall: Subject<void> = new Subject<void>();
  private cancelCall: Subject<void> = new Subject<void>();



  public upload(file: File, fileUrl: string) {
    this.fileUrl = fileUrl;
    this.file = file;
    this.initializeState();
    const reader = new FileReader();
    reader.onloadend = async (evt) => {
      if (evt.target.readyState === 2 && !this.cancelled) {
        const uri = this.fileUrl + '&comp=block&blockid=' + this.blockIds[this.blockIds.length - 1];
        const requestData = evt.target.result;
        const requestData2 = new Uint8Array((evt.target as any).result);

        this.http.put(uri, requestData,
          {
            headers: new HttpHeaders({ 'x-ms-blob-type': 'BlockBlob', 'Content-Type': 'application/octet-stream' }),
            reportProgress: true,
            responseType: "blob",
            observe: "events"
          })
          .pipe(takeUntil(this.cancelCall)).subscribe(async (event) => {
            if (event.type === HttpEventType.UploadProgress) {
              const percentComplete = Math.round(((this.bytesUploaded + event.loaded) / this.file.size) * 1000) / 10;
              this.progressCall.next(percentComplete);
            } else if (event instanceof HttpResponse) {
              this.bytesUploaded += requestData2.length;
              const percentComplete = Math.round(((this.bytesUploaded) / this.file.size) * 1000) / 10;
              this.progressCall.next(percentComplete);
              this.uploadFileInBlocks(reader);
            }
          }, (err => this.errorCall.next(err)));
      }
    };
    this.uploadFileInBlocks(reader);
    return {
      cancel: () => {
        this.cancelled = true;
      }
    };
  }

  private uploadFileInBlocks(reader) {
    if (!this.cancelled) {
      if (this.totalBytesRemaining > 0) {
        const fileContent = this.file.slice(this.currentFilePointer, this.currentFilePointer + this.maxBlockSize);
        const blockId = this.blockIdPrefix + this.prependZeros(this.blockIds.length, 6);
        this.blockIds.push(btoa(blockId));
        reader.readAsArrayBuffer(fileContent);
        this.currentFilePointer += this.maxBlockSize;
        this.totalBytesRemaining -= this.maxBlockSize;
        if (this.totalBytesRemaining < this.maxBlockSize) {
          this.maxBlockSize = this.totalBytesRemaining;
        }
      }
      else {
        this.commitBlockList();
      }
    }
  }
  private commitBlockList() {
    const uri = this.fileUrl + '&comp=blocklist';
    let requestBody = '<?xml version=\'1.0\' encoding=\'utf-8\'?><BlockList>';
    this.blockIds.forEach(blockId => {
      requestBody += '<Latest>' + blockId + '</Latest>';
    })

    requestBody += '</BlockList>';

    this.http.put(uri, requestBody,
      {
        headers: new HttpHeaders({ 'x-ms-blob-content-type': this.file.type }),
        observe: "events"
      })
      .pipe(takeUntil(this.cancelCall)).subscribe(evt => {
        if (evt instanceof HttpResponse) {
          this.uploadFinishedCall.next()
        }
      },
        (err => this.errorCall.next(err)));
  }

  private initializeState() {
    const blockSize = 1024 * 1024 * 100;
    let maxBlockSize = blockSize;
    const file = this.file;
    const fileSize = file.size;
    if (fileSize < blockSize) {
      maxBlockSize = fileSize;
    }
    this.totalBytesRemaining = fileSize;
    this.currentFilePointer = 0;
    this.blockIds = new Array();
    this.blockIdPrefix = 'block-';
    this.bytesUploaded = 0;
    this.cancelled = false;
    this.maxBlockSize = maxBlockSize;
  }
  private prependZeros(number, length) {
    let str = '' + number;
    while (str.length < length) {
      str = '0' + str;
    }
    return str;
  }

  public cancel() {
    this.cancelled = true;
    this.cancelCall.next();
  }
}

